import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as Preact from 'preact';

export interface Props {
    tabs: {
        header: string;
        id: string;
        types: ReadonlyArray<string>;
    }[];
    options: {
        id: string;
        image: string;
        type: string;
    }[];
    activeTab: string;
    onClick: (id: string) => void;
}
export const Component = (p: Props) => {
    return (
        <Tabs
            variant="scrollable"
            scrollButtons="auto"
            value={p.activeTab}
            sx={{
                width: '100%',
                maxWidth: 'fit-content',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {p.tabs.map((tab, i) => {
                return (
                    <Tab
                        label={tab.header}
                        value={tab.id}
                        disabled={!p.options.some(option => tab.types.includes(option.type))}
                        sx={{
                            color: 'text.secondary',
                            marginLeft: i === 0 ? 0 : '10px',
                            width: '100px',
                            fontSize: '14px',
                            letterSpacing: '2.8px',
                        }}
                        onClick={() => p.onClick(tab.id)}
                    />
                );
            })}
        </Tabs>
    );
};

Component.displayName = 'BottomTabContainer';
